import config from '../config'
import status from './status'

import Client from './Client'

import Auth from './endpoints/Auth'
import Activity from './endpoints/Activity'
import Child from './endpoints/Child'
import Employee from './endpoints/Employee'
import Invitation from './endpoints/Invitation'
import Klarna from './endpoints/Klarna'
import Parent from './endpoints/Parent'
import Profile from './endpoints/Profile'
import School from './endpoints/School'
import Search from './endpoints/Search'
import Signup from './endpoints/Signup'
import User from './endpoints/User'
import Topic from './endpoints/Topic'

const isBrowser = () => typeof window !== 'undefined'

const client = new Client(
  isBrowser() ? config.API_ENDPOINT : config.API_OVERRIDE,
  config.OAUTH2_CLIENT_ID,
)

const auth = new Auth(client)
const activity = new Activity(client)
const child = new Child(client)
const employee = new Employee(client)
const invitation = new Invitation(client)
const klarna = new Klarna(client)
const parent = new Parent(client)
const profile = new Profile(client)
const school = new School(client)
const topic = new Topic(client)
const search = new Search(client)
const signup = new Signup(client)
const user = new User(client)

export default {
  client,
  status,

  auth,
  activity,
  child,
  employee,
  invitation,
  klarna,
  parent,
  profile,
  search,
  school,
  topic,
  signup,
  user,
}



// WEBPACK FOOTER //
// ../source/api/index.js